// Página de fallo de compra en Mercado Pago
// Muestra mensaje de error y permite reintentar o volver al radar

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';

/**
 * Componente EcommerceFailure
 * Muestra mensaje de error después de fallar el pago en Mercado Pago
 */
const EcommerceFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 px-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 dark:bg-red-900 rounded-full p-4">
            <FaTimesCircle className="w-12 h-12 text-red-600 dark:text-red-400" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Pago Fallido
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Hubo un problema al procesar tu pago. Por favor, intenta nuevamente o selecciona otro método de pago.
        </p>
        
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate('/radar')}
            className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Volver al Radar
          </button>
          
          <button
            onClick={() => window.history.back()}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Reintentar
          </button>
        </div>
      </div>
    </div>
  );
};

export default EcommerceFailure;
